export default {
    add_playlist: "Ajouter liste de lecture",
    audio_save_error: "Une erreur s'est produite lors de l'enregistrement de l'audio",
    audio_save_success: "Audio enregistré avec succès",
    audios: "Audios",
    delete_playlist: "Ôter Playlist",
    duration: "Durée",
    episode: "Épisode",
    episode_plural: "Épisodes",
    favorite_podcast: "Podcast Préféré",
    how_do_you_rate_this_podcast: "Comment évaluez-vous ce podcast?",
    like_podcast: "Comme Podcast",
    listened: "Entendu",
    listening: "Écoute",
    loading_podcasts: "Chargement de podcasts",
    new_playlist: "Nouvelle liste de lecture",
    new_podcast: "Nouveau podcast",
    no_audios_on_podcast: "Pas d’audios sur le balado",
    no_podcasts_are_available_at_the_moment: "Aucun podcasts n'est actuellement disponible",
    no_podcasts_are_available_with_the_selected_filter: "Aucun podcasts disponible pour le filtre sélectionné",
    no_podcasts_found: "Podcasts introuvables",
    no_podcasts_found_with_this_filter: "Balados introuvables avec ce filtre",
    only_available_when_finished_podcast: "Disponible uniquement après avoir terminé le podcast",
    play_sound: "Lecture",
    playlist: "Playlist",
    playlist_save_success: "Liste de lecture sauvegardée",
    playlists: "Liste de lecture",
    podcast: "Balado",
    podcast_report: "Rapport de podcast",
    podcasts: "Balados",
    there_are_no_podcasts_avaliable_at_the_moment: "Pas de balados disponibles pour l’instant",
    to_listen: "Écouter",
    unexpected_error_try_again_later: "Erreur inattendue, veuillez réessayer plus tard",
    unfavorite_podcast: "Podcast Dépréféré",
    unlike_podcast: "Dismiss Podcast"
}
